import React from 'react'
import { useState } from 'react';
import {Link, NavLink} from "react-router-dom";
import {links} from "../../routes/NormalRoutes/Links";
import {FiSearch, FiChevronDown, FiChevronUp} from "react-icons/fi";
import SubmenuDropdown from "./SubmenuDropdown";

// {sidebar, setSidebar, ...props}

const NavContainer = (props) => {
  const [showSubmenu, setShowSubmenu] = useState(null);
  const [dropdown, setDropdown] = useState(false);

  const [dimensionsWidth, setDimensionsWidth] = useState(window.innerWidth);

  window.addEventListener("resize", handleResize);

  function handleResize() {
    setDimensionsWidth(window.innerWidth);

    positionDropdown(showSubmenu);

    return true;
  }

  const handleSidebar = () => {
    props.setSidebar(!props.sidebar);
  };

  const showSearch = () => {
    props.setSearchOverlay(true);
  };

  const showSubmenuHandler = (menuVoice) => {
    if (typeof menuVoice == "undefined" || menuVoice.length <= 0) {
      hideSubmenuHandler();

      return false;
    }

    if (
      typeof links[menuVoice] == "undefined" ||
      typeof links[menuVoice].submenu == "undefined"
    ) {
      hideSubmenuHandler();

      return false;
    }

    if (dropdown && showSubmenu == menuVoice) {
      if (
        typeof document
          .getElementById("divSubmenu")
          .getElementsByTagName("div")[0] == "undefined"
      ) {
        setDropdown(false);
      }
    } else {
      setDropdown(true);

      setShowSubmenu(menuVoice);
      positionDropdown(menuVoice);
    }

    return true;
  };

  const hideSubmenuHandler = () => {
    setDropdown(false);
    setShowSubmenu(null);

    return false;
  };

  const positionDropdown = (menuVoice) => {
    if (
      typeof menuVoice == "undefined" ||
      menuVoice == null ||
      menuVoice.length <= 0
    ) {
      return false;
    }

    let divMenuVoice = document.getElementById("menuVoice" + menuVoice);
    let positionMenuVoice = divMenuVoice.getBoundingClientRect();
    let divSubmenu = document.getElementById("divSubmenu");
    divSubmenu.style.position = "absolute";
    divSubmenu.style.left = positionMenuVoice.x - 15 + "px";
    //divSubmenu.style.minWidth = (divMenuVoice.offsetWidth + 25) + 'px';

    return true;
  };

  return (
    <div className="relative" onMouseLeave={hideSubmenuHandler}>
      <nav className="relative flex items-center lg:items-end justify-between lg:justify-between px-4 py-2 lg:px-0 lg:py-0">
        {/* branding */}
        <Link
          to="/"
          className="mobile-logo flex-shrink-0 lg:w-3/12 flex justify-center items-center"
        >
          <img src="/images/logo.png" alt="corcym logo" className="logo" />
        </Link>

        {/* links container */}
        <div className="hidden lg:flex flex-grow">
          <div className="overflow-y-hidden flex-shrink-0 flex items-center justify-around flex-grow px-3 h-12 xl:h-16 bg-blue-primary space-x-3">
            <ul className="w-full" style={{ display: "contents" }}>
              {links.map((link, key) => (
                <li
                  className="relative transition text-xs xl:text-sm 2xl:text-base uppercase font-medium h-full"
                  key={key}
                  style={{ display: "inline" }}
                >
                  <div
                    className="h-full d-flex items-center"
                    id={`menuVoice${key}`}
                  >
                    {link.submenu ? (
                      <div
                        className="h-full"
                        onMouseOver={() => showSubmenuHandler(key)}
                      >
                        <a
                          href={link.to}
                          style={{
                            float: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                          className="h-full uppercase font-medium text-gray-light hover:text-red-primary"
                          aria-haspopup="menu"
                          aria-expanded={dropdown ? "true" : "false"}
                        >
                          {link.title}
                          {showSubmenu == key && dropdown ? (
                            <FiChevronUp
                              style={{ float: "left" }}
                              className="my-auto ml-1 cursor-pointer h-full d-flex items-center"
                            />
                          ) : (
                            <FiChevronDown
                              style={{ float: "left" }}
                              className="my-auto ml-1 cursor-pointer h-full d-flex items-center"
                            />
                          )}
                        </a>
                      </div>
                    ) : (
                      <div className="hover:text-red-primary text-gray-light h-full d-flex items-center">
                        <a
                          href={link.to}
                          style={{
                            float: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                          className="h-full"
                          aria-haspopup="menu"
                        >
                          {link.title}
                        </a>
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-red-primary h-12 xl:h-16 2xl:w-24 flex items-center px-4 2xl:pl-8 2xl:pr-0 flex-shrink-0">
            <span className="text-xl xl:text-2xl 2xl:text-4xl text-white cursor-pointer">
              <FiSearch onClick={showSearch} />
            </span>
          </div>

          {/* {searchOverlay ? 
                        <SearchOverlay />
                        :
                        ''
                    } */}
        </div>

        {/* {hamburger button} */}
        <div
          className={`block w-8 h-6 lg:hidden relative cursor-pointer ${
            props.sidebar ? "menu-btn-active" : "menu-btn"
          }`}
          onClick={handleSidebar}
        >
          <div className="transition-all duration-300 h-1 w-8 bg-red-primary absolute"></div>
          <div className="transition-all duration-300 h-1 w-8 bg-red-primary absolute"></div>
          <div className="transition-all duration-300 h-1 w-8 bg-red-primary absolute"></div>
        </div>
      </nav>

      <div id="divSubmenu" style={{ zIndex: "999999" }}>
        {dropdown ? (
          <div className="bg-blue-primary overflow-y-hidden pb-2">
            <SubmenuDropdown submenus={links[showSubmenu].submenu} />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default NavContainer;
